/**
 * 项目详情：execReqsInfo / reqsInfo 默认值合并
 * - 存在 xxxDftValue 时，xxx 自身无值则取默认值
 * - 无值：null / undefined / '' / []
 * - 有值：含 0
 * - 合并后保留 *DftValue 字段
 */

const DFT_SUFFIX = 'DftValue';

/** 是否视为「无值」（需回退到 DftValue） */
const isEmptyValue = (val: unknown) => {
  if (val === null || val === undefined || val === '') return true;
  if (Array.isArray(val) && val.length === 0) return true;
  return false;
};

/**
 * 将对象中 *DftValue 合并到对应业务字段（原地修改，不删 DftValue）
 */
export const applyDftValues = <T extends Record<string, any>>(
  obj?: T | null
): T => {
  if (!obj || typeof obj !== 'object') return obj as T;

  Object.keys(obj).forEach(key => {
    if (!key.endsWith(DFT_SUFFIX)) return;
    const bizKey = key.slice(0, -DFT_SUFFIX.length);
    if (!bizKey) return;
    if (!(bizKey in obj) || isEmptyValue(obj[bizKey])) {
      obj[bizKey as keyof T] = obj[key as keyof T];
    }
  });

  return obj;
};
